import { render, staticRenderFns } from "./DiceRoller.vue?vue&type=template&id=53d89e92&scoped=true&"
import script from "./DiceRoller.vue?vue&type=script&lang=js&"
export * from "./DiceRoller.vue?vue&type=script&lang=js&"
import style0 from "./DiceRoller.vue?vue&type=style&index=0&id=53d89e92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d89e92",
  null
  
)

export default component.exports